import React from 'react';

import type { ChallengeStatus } from '../types';

interface ChallengeResultProps {
  status: ChallengeStatus;
}

const RESULT_CONFIG: Record<
  'passed' | 'failed' | 'timeout',
  { icon: string; color: string; bg: string; message: string }
> = {
  passed: {
    icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
    color: 'text-green-400',
    bg: 'border-green-400',
    message: 'Verificação concluída com sucesso!',
  },
  failed: {
    icon: 'M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z',
    color: 'text-red-400',
    bg: 'border-red-400',
    message: 'Verificação não aprovada. Fique atento à próxima.',
  },
  timeout: {
    icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
    color: 'text-yellow-400',
    bg: 'border-yellow-400',
    message: 'Tempo esgotado. Responda mais rápido na próxima vez.',
  },
};

export const ChallengeResult: React.FC<ChallengeResultProps> = ({ status }) => {
  const config = RESULT_CONFIG[status as keyof typeof RESULT_CONFIG];
  if (!config) return null;

  return (
    <div className="flex animate-fade-in flex-col items-center">
      <div className={`mb-4 rounded-full border-4 ${config.bg} p-4`}>
        <svg
          className={`h-20 w-20 ${config.color}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d={config.icon}
          />
        </svg>
      </div>
      <p
        className={`max-w-xs text-center text-lg font-semibold ${config.color}`}
      >
        {config.message}
      </p>
    </div>
  );
};
